import React from "react";
import { Building2, Shield } from "lucide-react";

export default function Company() {
  return (
    <section
      id="zastreseni"
      data-testid="company-section"
      className="relative bg-[#06080F] text-slate-300 py-16 border-t border-amber-300/10"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-5">
            <div className="inline-flex items-center gap-2 rounded-full border border-amber-300/20 bg-amber-300/5 px-3 py-1 text-[10px] uppercase tracking-[0.22em] text-amber-300/90">
              <Shield className="h-3 w-3" />
              Zastřešení projektu
            </div>
            <h2 className="font-heading mt-5 text-2xl sm:text-3xl font-bold text-white tracking-tight leading-tight">
              Projekt STK Komfort™ je obchodně a agenturně zastřešen společností
            </h2>
          </div>

          <div className="lg:col-span-7">
            <div className="rounded-2xl border border-amber-300/15 bg-white/[0.03] p-7 lg:p-8">
              <div className="flex items-start gap-4">
                <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-amber-300/10 border border-amber-300/20 text-amber-300 shrink-0">
                  <Building2 className="h-5 w-5" />
                </div>
                <div className="flex-1">
                  <div className="font-heading text-xl font-bold text-white">
                    UNOEXTREME Capital Group s.r.o.
                  </div>
                  <div className="mt-1 text-xs uppercase tracking-[0.18em] text-amber-300/80">
                    Společnost s ručením omezeným
                  </div>
                </div>
              </div>

              <dl className="mt-6 grid sm:grid-cols-2 gap-x-8 gap-y-3 text-sm">
                <Row k="IČO" v="09361430" />
                <Row k="Datum vzniku" v="27. 7. 2020" />
                <Row k="Sídlo" v="Děčínská 552/1, Střížkov, 180 00 Praha" />
                <Row k="Základní kapitál" v="1 000 000 Kč" />
                <Row k="Datová schránka" v="fy6ewyj" />
                <Row k="Spisová značka" v="C 442251/MSPH" />
                <Row k="Soud" v="Městský soud v Praze" full />
              </dl>
            </div>

            <p className="mt-5 text-xs text-slate-500 leading-relaxed">
              Koncept, strategii, webové zpracování, marketingovou strukturu, SEO směr a obchodní
              nastavení projektu vytvořil{" "}
              <span className="text-amber-300/90 font-semibold">Charlie Xavier De Acapulco</span>.
              Cílem bylo vytvořit moderní, důvěryhodnou a praktickou službu pro každého
              majitele vozidla ve Znojmě a okolí — bez front, bez stresu, s osobním přístupem.
            </p>
          </div>
        </div>

        {/* Koncept a profesionální zpracování */}
        <div className="mt-12 grid lg:grid-cols-12 gap-8 items-start border-t border-amber-300/10 pt-12">
          <div className="lg:col-span-5">
            <div className="inline-flex items-center gap-2 rounded-full border border-amber-300/20 bg-amber-300/5 px-3 py-1 text-[10px] uppercase tracking-[0.22em] text-amber-300/90">
              Autor projektu
            </div>
            <h3 className="font-heading mt-5 text-xl sm:text-2xl font-bold text-white tracking-tight leading-tight">
              Koncept a profesionální zpracování
            </h3>
          </div>
          <div className="lg:col-span-7">
            <p className="font-body text-sm text-slate-400 leading-relaxed">
              Projekt STK Komfort™ vznikl jako moderní auto služba bez starostí pro Znojmo
              a okolí. Celý koncept, strategii, webovou strukturu, marketingové nastavení
              a SEO směr vytvořil{" "}
              <span className="text-amber-200 font-semibold">Charlie Xavier De Acapulco</span>.
              Projekt je navržen tak, aby zákazníkům šetřil čas, zjednodušil komunikaci
              kolem vozidla a spojil důležité auto služby pod jednu přehlednou značku.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

function Row({ k, v, full }) {
  return (
    <div className={full ? "sm:col-span-2" : ""}>
      <div className="text-[10px] uppercase tracking-[0.18em] text-slate-500">{k}</div>
      <div className="mt-0.5 text-sm text-slate-200 font-medium">{v}</div>
    </div>
  );
}
